import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { removeColorIdForIri } from 'src/containers/ProjectDiagram/utils/colorIds';
import { removeDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { removeLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { removeMappingsForNode } from 'src/containers/ProjectDiagram/utils/mapping/removeMappingsForNode';
import { removeDomainFromAllAttributesData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/removeDomainFromAllAttributesData';
import { removeAllHierarchiesFromModelConceptClass } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/removeAllHierarchiesFromModelConceptClass';
import { disconnectAllRelationshipsFromClass } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/disconnectAllRelationshipsFromClass';

// use useRemoveModelConceptClass() since it also
// clears the diagram and closes drawers if necessary
export const removeModelConceptClass =
  (data: ModelConceptClass) => (model: Model) => {
    removeAllHierarchiesFromModelConceptClass(data)(model);
    disconnectAllRelationshipsFromClass(data)(model);
    removeDomainFromAllAttributesData(data.value)(model);

    removeMappingsForNode(data.key)(model);

    model.removeNodeData(data);
    removeColorIdForIri(data.value)(model);
    removeDescriptionForIri(data.value)(model);
    removeLabelForIri(data.value)(model);
  };
